<div class="selectUsersFromList_container">
<span class="selectUsersFromList_title">{{"chatView.selectPersonsOfInterestTitle" | gender | translate}}</span>
<span class="selectUsersFromList_subtitle">{{"chatView.selectPersonsOfInterestSubtitle" | gender | translate}}</span>

@if(selectedUsers.length > 0){
<mat-chip-set class="selectUsersFromList_chipSet" aria-label="Selected Users">
    <mat-chip *ngFor="let user of selectedUsers"
              class="selectUsersFromList_customChip"
                [removable]="true"
                (removed)="removeUser(user)">
        {{ user.firstName }} {{ user.lastName }}
        <mat-icon matChipRemove>close</mat-icon>
      <!-- <span class="material-symbols-outlined" matChipRemove>close</span> -->
  </mat-chip>
</mat-chip-set>
}

    <mat-divider></mat-divider>
    <mat-form-field class="selectUsersFromList_searchInput" appearance="outline">
        <mat-label>{{"chatView.selectPersonsOfInterestSearchInput" | translate}}</mat-label>
        <input matInput placeholder="{{'chatView.selectPersonsOfInterestSearchCallForAction' | gender | translate}}" [formControl]="searchCtrl">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

    <mat-divider></mat-divider>
   

    @if(isLoading){
    <div class="selectUsersFromList_loadingSpinnerContainer" >
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    }
    @else{
      <span class="selectUsersFromList_infoText">{{"chatView.selectPersonsOfInterestInfoText" | translate}}</span>
      <div class="selectUsersFromList_usersList" style="max-height: 300px; overflow-y: auto;">
        <mat-list>
          <mat-list-item *ngFor="let user of filteredUsers | async" (click)="!user.existsInUserCircle && addUser(user)">
            <mat-checkbox 
            color="primary"
            [checked]="selectedUsersIds.has(user.id) || user.existsInUserCircle"
            [disabled]="user.existsInUserCircle"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection(user, $event.checked)">
            {{ user.firstName }} {{ user.lastName }}
            </mat-checkbox>
          </mat-list-item>
        </mat-list>
      </div>
    }
    
      <div class="selectUsersFromList_buttonContainer">
        @if(user!.role == userRoleInstance.HR || user!.role == userRoleInstance.MANAGER){
        <button mat-raised-button class="selectUsersFromList_button"
        [style.backgroundColor]="'#FF6A49'"
        [style.color]="'#FFFFFF'"
        (click)="selectSecondLevelUsers()">
          {{(!secondLevelAdded ? "chatView.selectPersonsOfInterest_AddSecondLevel" : "chatView.selectPersonsOfInterest_removeSecondLevel") | translate}}
        </button>
        }
       
        <button mat-raised-button class="selectUsersFromList_button"
        color="primary"
        (click)="onClose()">
          {{"chatView.selectPersonsOfInterestDoneButton" | translate}}
        </button>
      </div>
</div>